
export default function ErrorPage(){
    return(
        <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
            <p>404 Error</p>
            <h2 className="text-4xl font-bold pt-3">Faqja nuk mund te gjendet</h2>
        </div>
    )
}